<template>
    <div v-if="user">
        <div class="box">
          <div class="headline">{{ trans('profile_preview') }}</div>
            <div class="row main-pics">
                <div id="profile-main-pic" class="profile-main-pic" @click="openGallery('clear')">
                    <div class="img"
                        v-if="!preloaders.clear && !defaultAvatarBackground.match(/default_180x180/)"
                        :style="{'background': defaultAvatarBackground}"
                    >
                      <div v-if="avatars.default.pending || avatars.default.rejected"
                           :class="{'pending': avatars.default.pending, 'rejected': avatars.default.rejected}"
                      ></div>
                    </div>
                    <div v-if="!preloaders.clear && !defaultAvatarBackground.match(/default_180x180/)"
                        @click.stop="clearAvatar('clear')" class="close">
                    </div>
                    <img v-else-if="preloaders.clear" class="preloader"
                        src="/assets/img/preloader.svg"
                        alt="">
                    <div class="preview-title">({{ trans('for_censored_app') }})</div>
                    <div class="title" v-if="!isApp">{{ trans('preview') }}</div>
                </div>

                <div id="profile-main-pic-adult" class="profile-main-pic" v-if="!isApp" @click.self="openGallery('adult')">
                    <div class="img"
                        v-if="!preloaders.adult && !getAdultAvatarStyle.match(/default_180x180/)"
                        :style="{'background': getAdultAvatarStyle}">
                    </div>
                    <div v-if="!preloaders.adult && !getAdultAvatarStyle.match(/default_180x180/)"
                        @click.stop="clearAvatar('adult')" class="close">
                    </div>
                    <img v-else-if="preloaders.adult" class="preloader"
                        src="/assets/img/preloader.svg"
                        alt="">
                    <div class="preview-title long">({{ trans('visible_only_uncensored_website') }})</div>
                    <div class="title">
                      <span class="red">{{ trans('hot') }}</span> {{ trans('alternative') }}
                    </div>
                </div>
            </div>

            <div class="headline profile_gallery">{{ trans('public_gallery') }}</div>
            <div class="media-catalog">
                <PhotoSlider/>
                <VideoSlider/>
            </div>
        </div>
        <div class="box">
            <div class="headline">{{ trans('display_name') }}</div>
            <div class="name-edit notranslate">
                <input
                    v-model="user.headline"
                    type="text"
                    name="headline"
                    class="form-control"
                    v-bind:data-vv-as="trans('display_name')"
                    v-validate="{required: true, min: 3, max: 32}"
                    @focus="rememberProfileOldValue"
                    @change="saveProfileChange"
                >
            </div>
            <span class="form-error" :class="{'is-visible': errors.has('headline')}">
              {{ errors.first('headline') }}
            </span>
        </div>
      <div class="box">
        <div class="headline">{{ trans('display_link') }}</div>
        <div class="link-edit notranslate d-flex">
          <div class="link-sign">@</div>
          <input
              v-model="user.handle"
              type="text"
              name="handle"
              class="form-control"
              v-bind:data-vv-as="trans('display_link')"
              v-validate="{required: true, min: 3, max: 15, regex:/^[a-zA-Z0-9\-_.]+$/}"
              @focus="rememberProfileOldValue"
              @change="saveProfileChange"
          >
        </div>
        <span class="form-error" :class="{'is-visible': errors.has('handle')}">
              {{ errors.first('handle') }}
            </span>
      </div>
        <div class="box about_block">
          <HandlesList :style="{'bottom' : (this.textarea.height ? this.textarea.height + 30 : this.textarea.height) + 'px'}" @close-handles-list="closeHandlesList" @choose-handle="chooseHandle" v-if="search_handle" :text="search_handle"></HandlesList>
          <div class="headline">{{ trans('about_me') }}</div>
            <div class="text" :style="{'padding-bottom': textarea.height ? 30 + 'px' : 0}">
                <textarea
                    v-model="user.about"
                    :rows="textarea.rows + 1"
                    name="about"
                    ref="textAreaAbout"
                    maxlength="300"
                    class="form-control no-swiping"
                    @change="saveProfileChange"
                    @input="resizeTextArea"
                    @blur="unfocusTextArea"
                    @keyup="fixAboutLength"
                    :placeholder="trans('main_profile_about')"></textarea>
            </div>
        </div>
        <div class="tags">
            <form @submit.prevent="onSubmit" class="tag edit notranslate">
                <input type="text" maxlength="50" v-model='newTag'
                    class="form-control no-swiping" @keyup.enter.prevent="addTag"
                       @keydown.space.prevent
                    v-bind:placeholder="trans('main_add_tag')">
            </form>
            <div class="tag added" v-if="user.tags && user.tags.length"
                @click="deleteTag(tag)"
                v-for="tag in user.tags">
                <span class="notranslate">{{ tag.name }}</span>
            </div>
        </div>
        <div class="box">
            <div class="headline">{{ trans('main_statistics') }}</div>
            <div class="row">
                <div class="title">{{ trans('height') }}</div>
                <div class="field">
                    <select class="form-control no-swiping" name="height" v-model="user.height"
                            @change="saveProfileChange">
                        <option value="">---</option>
                        <option v-for="(value, key) in options.heights" :value="key">{{ value }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="title">{{ trans('weight') }}</div>
                <div class="field">
                    <select class="form-control no-swiping" name="weight" v-model="user.weight"
                            @change="saveProfileChange">
                        <option value="">---</option>
                        <option v-for="(value, key) in options.weights" :value="key">{{ value }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="title">{{ trans('body') }}</div>
                <div class="field">
                    <select class="form-control no-swiping" name="body" v-model="user.body"
                            @change="saveProfileChange">
                        <option value="">---</option>
                        <option v-for="(value, key) in options.bodyTypes" :value="key">{{ transBody(value) }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="title">{{ trans('position') }}</div>
                <div class="field">
                    <select class="form-control no-swiping" name="position"
                            v-model="user.position" @change="saveProfileChange">
                        <option value="">---</option>
                        <option :value="key" v-for="(value, key) in options.positionTypes">{{ transPosition(value)
                            }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="title">{{ trans('penis') }}</div>
                <div class="field">
                    <select class="form-control no-swiping" name="penis" v-model="user.penis"
                            @change="saveProfileChange">
                        <option value="">---</option>
                        <option v-for="(value, key) in options.penisSizes" :value="key">{{ value }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="title">{{ trans('hiv') }}</div>
                <div class="field">
                    <select class="form-control no-swiping" name="hiv" v-model="user.hiv"
                            @change="saveProfileChange">
                        <option value="">---</option>
                        <option :value="key" v-for="(value, key) in options.hivTypes">{{ transHiv(value) }}</option>
                    </select>
                </div>
            </div>
        </div>

      <div class="box social">
        <div class="headline">{{ trans('follow') }}</div>
        <div v-for="(s_network) in ['jff_link','instagram_link','x_link','tiktok_link']" class="row">
          <div class="title icon" :class="'icon-'+s_network"></div>
          <div class="field social_network">
            <input @change="saveProfileChange"
                   :placeholder="trans('enter_your_social_network_handle',{social_network: trans(s_network)})"
                   type="text"
                   :name="s_network"
                   v-model="user[s_network]"
                   class="form-control" />
          </div>
        </div>
      </div>

      <div class="box buddy-links">
        <div class="row">
          <div class="title icon">@</div>
          <div class="field buddy-link">
            <HandlesList ref="buddyLinksHandleList" :except="user.buddy_links" @close-handles-list="closeHandlesList" @choose-handle="chooseAttachedLink" v-if="search_handle_social_link" :text="search_handle_social_link"></HandlesList>
            <input @keyup.enter.prevent="addBuddyLinkManually" :disabled="user.buddy_links.length >= 20" ref="linksInput" @keyup="searchHandleCheckForSocialLinks" :placeholder="buddyLinksPlaceholder" type="text" value="" class="form-control" />
          </div>
        </div>
        <div class="buddy-links-list">
          <div class="buddy-links-list-row" v-for="buddy_link in buddyLinksReverse">
            <div class="buddy-links-list-row-img" @click="clickBuddyLink" :data-issue-type="buddy_link.event_type" :data-issue="buddy_link.issue_type" :data-issue-id="buddy_link.issue_id" :style="{'background-image':'url('+buddy_link.photo_small+')'}"></div>
            <div :data-issue-type="buddy_link.event_type" :data-issue="buddy_link.issue_type" :data-issue-id="buddy_link.issue_id" class="buddy-links-list-row-details"  @click="clickBuddyLink">
                <div :data-issue-type="buddy_link.event_type" :data-issue="buddy_link.issue_type" :data-issue-id="buddy_link.issue_id" class="buddy-links-list-row-details-headline">{{buddy_link.headline}}</div>
                <div :data-issue-type="buddy_link.event_type" :data-issue="buddy_link.issue_type" :data-issue-id="buddy_link.issue_id" class="buddy-links-list-row-details-handle">@{{buddy_link.handle}}</div>
            </div>
            <div class="buddy-links-list-row-cancel" @click="removeBuddyLink(buddy_link)">

            </div>
          </div>
        </div>
      </div>
        <PhotoGallery/>
        <VideoGallery/>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import PhotoSlider from '@profile/views/widgets/form/media/PhotoSlider.vue'
    import VideoSlider from '@profile/views/widgets/form/media/VideoSlider.vue'
    import PhotoGallery from '@profile/views/widgets/form/media/PhotoGallery.vue'
    import VideoGallery from '@profile/views/widgets/form/media/VideoGallery.vue'
    import discoverModule from "../../../../discover/module/store/type";
    import HandlesList from "../../../../buddy/views/widgets/HandlesList.vue";
    import Reply from "../../../../chat/views/widgets/Reply.vue";
    export default {
        mixins: [
          require('@general/lib/mixin').default,
          require('@general/lib/mixin-clubs').default,
          require('@general/lib/mixin-events').default
        ],
        components: {
          Reply, HandlesList,
            PhotoSlider,
            VideoSlider,
            PhotoGallery,
            VideoGallery,
        },
        data() {
            return {
                search_handle:false,
                search_handle_social_link: false,
                tags: [],
                newTag: '',
                preloaders: {
                    clear: false,
                    adult: false,
                },
                avatars: {
                    default: {
                        pending: false,
                        rejected: false
                    },
                    adult: {

                    }
                },
                textarea: {
                  rows: 1,
                  height: 45,
                  scrollHeight: null,
                  baseScrollHeight: 0,
                },
            }
        },
        computed: {
            ...mapState({
                user: 'profile',
                options: 'profileOptions'
            }),
          buddyLinksPlaceholder(){
              return this.user.buddy_links.length >= 20 ? this.trans('you_can_add_only_twenty_links') : this.trans('add_links_to_profiles_events_clubs');
          },
            buddyLinksReverse(){
              return [].concat(this.user.buddy_links).reverse();
            },
            defaultAvatar(){
                let user = this.user
                return user.avatars && user.avatars.default
            },
            adultAvatar(){
                let user = this.user
                return user.avatars && user.avatars.adult
            },
            defaultAvatarBackground(){
                if (this.defaultAvatar) {
                    return `url(${this.defaultAvatar.photo_small}) center / cover`
                } else {
                    return 'url("/assets/img/default_180x180.jpg") center / cover'
                }
            },
            getAdultAvatarStyle(){
                if (this.adultAvatar) {
                    if (this.adultAvatar.rejected) {
                        return '#5a5a5a'
                    } else {
                        return `url(${this.adultAvatar.photo_small}) center / cover`
                    }
                } else {
                    return 'url("/assets/img/default_180x180.jpg") center / cover'
                }
            },
        },
        methods: {
          addBuddyLinkManually(){
            let self = this;
            $.each(this.$refs.buddyLinksHandleList.handles, function(key,val){
              if(val.handle.toLowerCase() === self.$refs.linksInput.value.toLowerCase()){
                  self.chooseAttachedLink(val.handle,val);
              }
            })
          },
          clickBuddyLink(e){
              this.closeHandlesList();
              this.openLink(e);
          },
          removeBuddyLink(handle){
            this.user.buddy_links = this.user.buddy_links.filter(function( link ) {
              return link.handle !== handle.handle;
            });
            axios.post('/api/user_buddy_links/delete', handle)
                .then(({data}) => {

                })
          },
          chooseAttachedLink(link,info){
              this.user.buddy_links.push(info);
              this.closeHandlesList();
              this.$refs.linksInput.value = '';

            axios.post('/api/user_buddy_links/add', info)
                .then(({data}) => {

                })
          },
          chooseHandle(handle){
            if(this.$refs.textAreaAbout) {
              let cursorPosition = this.$refs.textAreaAbout.selectionStart
              let text = this.user.about.substring(0, cursorPosition)
              let arr = text.split("@")
              arr.pop()
              let link_str = arr.join('@') + '@' + handle;
              this.user.about = link_str + ' ' + this.user.about.substring(cursorPosition)
              this.$nextTick(() => {
                this.$refs.textAreaAbout.selectionStart = link_str.length + 1;
                this.$refs.textAreaAbout.selectionEnd = link_str.length + 1;
                this.closeHandlesList()
                this.$refs.textAreaAbout.focus()
                this.fixAboutLength();
              });
            }
          },
          closeHandlesList(){
            this.search_handle = false;
            this.search_handle_social_link = false;
            this.$emit('changeScrollState', true);
          },
          searchHandleCheckForSocialLinks(){
            if(this.$refs.linksInput) {
              let word = this.$refs.linksInput.value;
              if (word.length >= 3) {
                this.$emit('changeScrollState', false);
                this.search_handle_social_link = word
                return null;
              }
            }

            this.$emit('changeScrollState', true);
            this.search_handle = false;
          },
          searchHandleCheck(){
            if(this.$refs.textAreaAbout) {
              let cursorPosition = this.$refs.textAreaAbout.selectionStart
              let lines = this.user.about.substring(0,cursorPosition).split("\n")
              let words = lines[lines.length - 1].split(" ")
              if (words[words.length - 1].indexOf('@') === 0 && words[words.length - 1].length > 3) {
                this.$emit('changeScrollState', false);
                this.search_handle = words[words.length - 1]
                return null;
              }
            }

            this.search_handle = false;
            this.$emit('changeScrollState', true);
          },
            onSubmit(){
              return false;
            },
            fixAboutLength(){
              this.searchHandleCheck();
              setTimeout(this.resizeTextArea, 100)
              if(this.user.about.length > 300){
                this.user.about = this.user.about.substring(0,300);
              }
            },
            async clearAvatar(slot){
                let photo = slot === 'adult' ?
                    this.adultAvatar
                    :
                    this.defaultAvatar

                if (!photo) {
                    this.openGallery(slot)
                    return false
                }

                app.$emit('avatar-preloader', { slot, value: true })
                await this.makePhotoVisibleTo(photo.id, 'private')
                          .then(response => {
                            let defaultImg = '/assets/img/default_180x180.jpg'
                            let usersAround = this.$store.state.discoverModule.usersAround;
                            if (usersAround) {
                              let index = usersAround.findIndex(el => el.id === auth.getUserId());

                              if (index !== -1) {
                                  this.$store.state.discoverModule.usersAround[index].photo_small = defaultImg;
                                  let haveUserInfo = typeof this.$store.state.usersInfo[auth.getUserId()] != 'undefined';
                                  if (haveUserInfo) {
                                    this.$store.state.usersInfo[auth.getUserId()].photo_small = defaultImg;
                                    this.$store.state.usersInfo[auth.getUserId()].photo_orig = defaultImg;
                                  }
                              }
                            }
                          })
                await this.$store.dispatch('loadCurrentUserInfo')
                app.$emit('avatar-preloader', { slot, value: false })
            },
            openGallery(slot){
                app.$emit('show-photo-gallery', slot)
            },
            addTag() {
                let tagValue = _.trimStart(this.newTag, '# ');
                tagValue = _.trimEnd(tagValue, ' ');
                if (!tagValue) {
                    return;
                }

                this.newTag = '';
                let self = this;
                axios.post('/api/tags/add', {name: tagValue})
                    .then(({data}) => {
                        if (data && data.length) {
                          $.each(data,function(key,val){
                            self.user.tags.push(val);
                          })
                        }
                    })
            },
            deleteTag(tag) {
                const index = this.user.tags.indexOf(tag);
                const removedArray = this.user.tags.splice(index, 1);

                axios.post('/api/tags/delete', {id: tag.id})
                    .catch((error) => {
                        this.user.tags.splice(index, 0, removedArray[0]);
                    });
            },
            unfocusTextArea() {
               if (this.user.about === '') {
                  this.resetTextAreaSize();
               }
            },
            resetTextAreaSize(){
              this.textarea.rows   = 1
              this.textarea.height = 45
            },
            resizeTextArea() {

              let rowsCount = Math.ceil((this.$refs.textAreaAbout.scrollHeight - 12 * 2) / 21)

              this.textarea.rows = rowsCount + 1 > 6 ? 6 : rowsCount

              if (!this.isMobile) {
                this.textarea.height = this.textarea.rows * 21 + 12 * 2
              } else {
                if (rowsCount === 1) this.textarea.height = null
                else if (rowsCount === 2) this.textarea.height = 59
                else if (rowsCount === 3) this.textarea.height = 80
                else if (rowsCount === 4) this.textarea.height = 101
                else if (rowsCount === 5) this.textarea.height = 122
                else if (rowsCount >= 6) this.textarea.height = 143
              }
            },
            setAvatarPreloader(payload){
                this.preloaders[payload.slot] = payload.value
            }
        },
        watch: {
          defaultAvatar(value) {
            if (value) {
              this.avatars.default = {pending: value.pending, rejected: value.rejected}
            }
          }
        },
        activated() {
            this.$store.dispatch('loadCurrentUserInfo')
        },
        mounted() {
            let user = this.user;

            if (user) {
                let defaultAvatar = user.avatars?.default;
                this.avatars.default = {pending: defaultAvatar?.pending, rejected: defaultAvatar?.rejected}
            }

            app.$on('avatar-preloader', this.setAvatarPreloader)
        },
        destroyed() {
            app.$off('avatar-preloader')
        }
    }
</script>
